/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Citation_HintInputs */

const en_reading_class_citation_hint = /** @type {(inputs: Reading_Class_Citation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Like (Smith, 2020) or [12]`)
};

const es_reading_class_citation_hint = /** @type {(inputs: Reading_Class_Citation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como (Smith, 2020) o [12]`)
};

/**
* | output |
* | --- |
* | "Like (Smith, 2020) or [12]" |
*
* @param {Reading_Class_Citation_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_citation_hint = /** @type {((inputs?: Reading_Class_Citation_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Citation_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_citation_hint(inputs)
	return en_reading_class_citation_hint(inputs)
});